<template>
  <div>
    <h1>Macheo</h1>
    <MacheoAdmin v-if="$store.getters.user.roles.includes('MACHEOADMIN')" />
    <v-layout>
      <v-flex sm6 md6 lg6>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Nombre</th>
                <th class="text-left"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="grupo in grupos" :key="grupo.id">
                <td>{{ grupo.nombre }}</td>
                <td>
                  <v-btn small color="info" @click="add10(grupo, 'Pendiente')" :disabled="loading || macheos.length > 10"
                    :loading="loading">Cargar pendientes</v-btn>
                  <span> - </span>
                  <v-btn small color="info" @click="add10(grupo, 'Omitido')" :disabled="loading || macheos.length > 10"
                    :loading="loading">Cargar omitidos</v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-flex>
      <v-flex sm6 md6 lg6>
        <EstadoMacheo />
      </v-flex>
    </v-layout>

    <v-text-field v-model="searchText" append-icon="search" label="Buscar" single-line hide-details
      @keypress.enter="search"></v-text-field>

    <template v-if="macheos.length > 0">
      <span class="red--text" v-if="errorMessage">{{ errorMessage }}</span>

      <v-data-table v-model="macheoSelected" single-select :items-per-page="5" show-select :headers="headers"
        :items="macheos" item-key="id" class="elevation-1">
        <template v-slot:[`item.playAudio`]="props">
          <v-row justify="center" align="center" class="flex-nowrap">
            <v-col class="text-center" v-if="props">
              <div v-if="props.item.conAudio">
                <div v-if="props.item.playingStatus == 'Error'" class="red--text">error</div>
                <v-btn v-if="props.item.playingStatus != 'Playing'" small :loading="props.item.playingStatus == 'Loading'" color="white"
                  @click="() => { play(props.item) }"><v-icon>mdi-play-circle</v-icon></v-btn>
                <v-img v-if="props.item.playingStatus == 'Playing'" src="img/icons8-audio.gif"> </v-img>
              </div>
            </v-col>
          </v-row>
        </template>
        <template v-slot:[`item.controls`]="props">
          <v-row justify="center" align="center" class="flex-nowrap">
            <v-col class="text-center">
              <v-btn small color="warning" @click="
                confirmarComparacion({
                  codWorkSq: null,
                  id: props.item.id,
                  observacion: null,
                  tipo: 'excluido',
                })
                ">
                Excluir
              </v-btn>
            </v-col>
            <v-col class="text-center">
              <v-btn small color="warning" @click="
                confirmarComparacion({
                  codWorkSq: null,
                  id: props.item.id,
                  observacion: null,
                  tipo: 'internacional',
                })
                ">
                INTER.
              </v-btn>
            </v-col>
            <v-col class="text-center">
              <v-btn small color="warning" @click="
                confirmarComparacion({
                  codWorkSq: null,
                  id: props.item.id,
                  observacion: null,
                  tipo: 'ONI',
                })
                ">
                ONI NAC
              </v-btn>
            </v-col>
            <!-- <v-col class="text-center">
              <v-btn small color="warning" @click="
                confirmarComparacion({
                  codWorkSq: null,
                  id: props.item.id,
                  observacion: null,
                  tipo: 'Publicidad',
                })
                ">
                Publicidad
              </v-btn>
            </v-col> -->
            <v-col class="text-center">
              <v-btn small color="warning" @click="
                confirmarComparacion({
                  codWorkSq: null,
                  id: props.item.id,
                  observacion: null,
                  tipo: 'omitido',
                })
                ">
                Omitir
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </template>

    <div>
      <template v-if="macheoSelected.length == 1">
        <v-form @submit.prevent="buscarOdenPago" id="busqueda-form">
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="3">
                <v-text-field type="text" label="Ingrese el nombre de la obra"
                  hint="Ej. YPA% ..puede usar el signo % como comodin" v-model="nombreObra" maxlength="100"
                  @keydown.enter="buscarObra" />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field type="text" label="Ingrese el nombre de algun autor" hint="Ej. BORGHETTI"
                  v-model="nombreAutor" @keydown.enter="buscarObra" maxlength="100" />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-btn color="info" @click="buscarObra" :loading="loading">Buscar</v-btn>
              </v-col>
            </v-row></v-container>
        </v-form>
      </template>

      <h5 class="mx-auto mt-5" v-if="loading">Cargando . . .</h5>
      <template v-if="obras.length > 0">
        <v-data-table v-model="obraSelected" single-select :items-per-page="5" show-select :headers="headersObra"
          :items="obras" item-key="codWorkSq" class="elevation-1">
        </v-data-table>
      </template>
    </div>
    <template v-if="macheoSelected.length == 1 && obraSelected.length == 1">
      <ConfirmarMacheo :showDialog="mostrarConfirmar" :obraMacheo="macheoSelected[0]" :obraSgs="obraSelected[0]"
        @cancelar="cancelarComparacion" @confirmar="confirmarComparacion" />
    </template>
    <audio ref="audio">
      Your browser does not support the &lt;audio&gt; tag.
      <source ref="source" src="" type="audio/wav" />
    </audio>
  </div>
</template>
<script>
import axios from "axios";
import ConfirmarMacheo from "@/components/macheo/ConfirmarMacheo";
import EstadoMacheo from "@/components/macheo/EstadoMacheo";
import MacheoAdmin from "@/components/macheo/MacheoAdmin.vue";
// import PlayBmatAudio from "@/components/bmat/PlayBmatAudio.vue";


export default {
  data() {
    return {
      searchText: "",
      mostrarConfirmar: false,
      loading: false,
      errorMessage: "",
      macheoSelected: [],
      macheos: [],
      grupos: [],
      headers: [
        {
          text: "Play",
          align: "start",
          sortable: false,
          value: "playAudio",
        },
        {
          text: "Titulo Original",
          align: "start",
          sortable: false,
          value: "nombreObra",
        },
        { text: "origen", align: "end", sortable: false, value: "origen" },
        { text: "origenId", align: "end", sortable: false, value: "origenId" },
        {
          text: "codWorkSq",
          align: "end",
          sortable: false,
          value: "codWorkSq",
        },
        { text: "estado", align: "end", sortable: false, value: "estado" },
        { text: "Iswc", aling: "start", sortable: false, value: "iswc" },
        { text: "Autores", sortable: false, value: "autores" },
        { text: "Artistas", sortable: false, value: "artistas" },
        { text: "Accion", value: "controls", sortable: false },
      ],

      //obras

      obraSelected: [],
      headersObra: [
        {
          text: "Titulo Original",
          align: "start",
          sortable: false,
          value: "title",
        },
        { text: "CodWorkSq", value: "codWorkSq" },
        { text: "IdTema", value: "idTema" },
        { text: "ISWC", value: "iswc" },
        { text: "Autores", value: "autores" },
      ],
      obras: [],
      nombreObra: "",
      nombreAutor: "",
    };
  },
  mounted() {
    this.getByUser();
    this.getGrupoMacheoAbierto();
  },
  methods: {
    add10(grupo, estado) {
      console.log(estado);
      this.loading = true;
      axios
        .post(`/macheo/add10/${grupo.id}?estado=${estado}`)
        .then(() => {
          this.getByUser();
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    getGrupoMacheoAbierto() {
      axios
        .get("/macheo/findPendientes")
        .then((res) => {
          this.grupos = res.data;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    getByUser() {
      axios
        .get("/macheo/getByUser")
        .then((res) => {
          this.macheos = res.data;
          this.loading = false;
          if (res.data.length == 0) {
            this.message = "no hay mas registros";
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    getLast10() {
      axios
        .get("/macheo/getLast10")
        .then((res) => {
          this.macheos = res.data;
          this.loading = false;
          if (res.data.length == 0) {
            this.message = "no hay mas registros";
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    buscarObra() {
      this.obras = [];
      this.errorMessage = "";

      this.loading = true;

      const params = {
        nombreObra:
          this.nombreObra.trim().length == 0
            ? "%"
            : this.nombreObra.trim().toUpperCase(),
        nombreAutor: `${this.nombreAutor
          .trim()
          .toUpperCase()
          .replace(" ", "%")}%`,
      };

      axios
        .get("/sgs/obras", { params })
        .then((response) => {
          this.obras = response.data;
          this.loading = false;
          if (this.obras.length == 0) {
            this.errorMessage = "No se encontraron coincidencias";
          }

          if (this.obras.length == 1) {
            this.obraSelected[0] = this.obras[0];
            this.mostrarConfirmar = true;
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
          this.loading = false;
        });
    },
    cancelarComparacion() {
      this.mostrarConfirmar = false;
    },
    confirmarComparacion(datoMacheo) {
      console.log(datoMacheo);
      this.mostrarConfirmar = false;
      this.macheos = this.macheos.filter((o) => o.id != datoMacheo.id);

      this.obras = [];
      this.obraSelected = [];
      this.macheoSelected = [];
      this.nombreAutor = "";
      this.nombreObra = "";

      axios
        .post("/macheo/machear", datoMacheo)
        .then(() => { })
        .catch((err) => {
          this.loading = false;
          this.errorMessage = err.response.data;
          console.log(err);
        });
    },
    save(fileId) {
      console.log(fileId);
    },
    search() {
      if (!this.searchText) {
        this.getByUser();
        return;
      }

      if (this.searchText.toUpperCase() == ":U10") {
        this.getLast10();
        return;
      }

      axios
        .get("/macheo/search", { params: { q: this.searchText } })
        .then((res) => {
          this.macheos = res.data.map(r => {
            return { ...r, playingStatus: 'new' }
          });
          this.loading = false;
          if (res.data.length == 0) {
            this.message = "no hay mas registros";
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    async play(item) {

      item.playingStatus = 'Loading';

      const { data } = await axios.get("/bmat/audio/" + item.origenId, {
        responseType: 'arraybuffer',
        headers: {
          'Content-Type': 'audio/wav'
        }
      }).catch(() => {
        // console.log('err',err);
        item.playingStatus = 'Error';
        return { data: false };
      });

      if (!data) return;

      const blob = new Blob([data], {
        type: 'audio/wav'
      });

      const url = URL.createObjectURL(blob);

      const audio = this.$refs.audio; //document.getElementById('audio');
      const source = this.$refs.source; //document.getElementById('source');

      // Insert blob object URL into audio element & play.
      source.src = url;
      audio.load();

      audio.addEventListener('ended', () => {
        item.playingStatus = 'Stoped';
      })


      this.macheos.forEach(m => {
        if (m.playingStatus == 'Playing') {
          m.playingStatus = 'Stopped'
        }
      });

      audio.play();
      item.playingStatus = 'Playing';
    }
  },
  watch: {
    macheoSelected: function (val) {
      if (val == null || val.length == 0) {
        return;
      }
      console.log("****", val);
      if (val && val[0].autores && val[0].autores.length > 5) {
        this.nombreAutor = "%" + val[0].autores.slice(0, 5) + "%";
      } else {
        this.nombreAutor = "";
      }
      this.nombreObra = val[0].nombreObra.replace("Ñ", "%");
      this.nombreObra = val[0].nombreObra.replace("'", "%");
      this.nombreObra = val[0].nombreObra.replace("Y", "%");
      this.nombreObra = val[0].nombreObra.replace("I", "%");
      this.nombreObra = val[0].nombreObra.replace("H", "%");
      this.nombreObra = val[0].nombreObra.replace("J", "%");
      this.obraSelected = [];
      this.obras = [];
      this.buscarObra();
    },
    obraSelected: function (val) {
      if (val == null || val.length == 0) {
        return;
      }
      console.log("*****", val);
      setTimeout(() => {
        this.mostrarConfirmar = true;
      }, 100);
    },
  },
  components: {
    ConfirmarMacheo,
    EstadoMacheo,
    MacheoAdmin,
    // PlayBmatAudio,
  },
};
</script>
